"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortDirection = exports.UAEStates = exports.KSAStates = exports.EquipmentTypes = exports.getCountry = exports.Country = exports.Geo = exports.ReportFormatType = exports.Collection = exports.FileType = exports.Types = void 0;
var Types;
(function (Types) {
    Types["Point"] = "Point";
    Types["Polygon"] = "Polygon";
})(Types = exports.Types || (exports.Types = {}));
var FileType;
(function (FileType) {
    FileType["IMAGE_PNG"] = "image/png";
    FileType["IMAGE_JPG"] = "image/jpeg";
    FileType["PDF"] = "application/pdf";
    FileType["Text"] = "text/plain";
})(FileType = exports.FileType || (exports.FileType = {}));
// list of collection and subcollection names
var Collection;
(function (Collection) {
    Collection["GeneratedQuotation"] = "generated_quotations";
    Collection["Groups"] = "groups";
    Collection["GroupEquipments"] = "group_equipments";
    Collection["GroupDocuments"] = "group_documents";
    Collection["GroupLocationMarker"] = "group_location_markers";
    Collection["GroupAlertSetting"] = "group_alert_settings";
    Collection["GroupTripPaths"] = "group_trip_paths";
    Collection["TableauDashboard"] = "tableau_dashboard";
    Collection["Users"] = "users";
    Collection["UserDocuments"] = "user_documents";
    Collection["EquipmentGeofenceHistory"] = "equipment_geofence_history";
    Collection["MaintenanceSchedules"] = "maintenance_schedules";
    Collection["Accounts"] = "accounts";
    Collection["AccountDocuments"] = "account_documents";
    Collection["AccountPaymentNotifications"] = "account_payment_notifications";
    Collection["AccountMetaDocuments"] = "account_meta_documents";
    Collection["GroupAutomatedReports"] = "group_automated_reports";
    Collection["AccountAutomatedReportHistory"] = "account_automated_report_history";
    Collection["AccountBilling"] = "account_billing";
    Collection["AccountInvoice"] = "account_invoices";
    Collection["AccountExtension"] = "account_extensions";
    Collection["Extensions"] = "extensions";
    Collection["Equipments"] = "equipments";
    Collection["EquipmentDocuments"] = "equipment_documents";
    Collection["EquipmentHistory"] = "equipment_history";
    Collection["EquipmentAlerts"] = "equipment_alerts";
    Collection["EquipmentAvailability"] = "equipment_availability";
    Collection["Listings"] = "listings";
    Collection["EquipmentMaintenanceHistory"] = "equipment_maintenance_history";
    Collection["Operators"] = "operators";
    Collection["OperatorDocuments"] = "operator_documents";
    //Procurement = 'procurement', //old one (will be removed after all is done)
    Collection["Procurements"] = "procurements";
    Collection["OperatorAwards"] = "operator_awards";
    Collection["OperatorHistory"] = "operator_history";
    Collection["Requests"] = "requests";
    Collection["RequestUpdates"] = "request_updates";
    Collection["RequestDocuments"] = "request_documents";
    Collection["RFQs"] = "rfqs";
    Collection["RFQResponses"] = "rfq_responses";
    Collection["RFQResponseHistory"] = "rfq_response_history";
    Collection["RFQInspectionRequests"] = "rfq_inspection_requests";
    Collection["CreditApplications"] = "credit_applications";
    Collection["DocusignEnvelopes"] = "docusign_envelopes";
    Collection["Timesheets"] = "timesheets";
    Collection["TimesheetsTelematics"] = "timesheets_telematics";
    Collection["AnalyticsTimesheet"] = "analytics_timesheet";
    Collection["Inquiries"] = "inquiries";
    Collection["InquiryDocuments"] = "inquiry_documents";
    Collection["Logs"] = "logs";
    Collection["Metrics"] = "metrics";
    Collection["Careers"] = "careers";
    Collection["SkidHistory"] = "skidhistories";
    Collection["Notification"] = "notifications";
    Collection["UserPoints"] = "user_points";
    Collection["SalesMetrics"] = "sales_metrics";
    Collection["Lead"] = "leads";
    Collection["Admin"] = "admin";
    Collection["SendgridFlaggedEmails"] = "send_grid_flagged_emails";
    Collection["Sendgrid"] = "Sendgrid";
    Collection["InsightsAction"] = "insights_actions";
    // Logistics
    Collection["Logistics"] = "logistics";
    Collection["LogisticsUpdates"] = "logistics_updates";
    Collection["OTP"] = "otps";
    Collection["Suppressions"] = "suppressions";
    Collection["Settings"] = "settings";
    Collection["CronJobs"] = "cron_jobs";
    Collection["CronJobAcks"] = "cron_job_acks";
    Collection["CronJobsHistory"] = "cron_jobs_history";
    Collection["MonthlyFinances"] = "monthly_finances";
    Collection["HubspotIds"] = "hubspot_ids";
    Collection["Marketplace"] = "marketplace";
    Collection["CompletedTrips"] = "completed_trips";
    Collection["PlcInjestion"] = "plcinjestions";
    Collection["PlcCompressorInjestion"] = "plccompressorinjestions";
    Collection["Vision"] = "vision";
    Collection["Lookups"] = "lookups";
    Collection["FinanceSettings"] = "finance_settings";
    Collection["TimesheetsUtilization"] = "timesheets_utilization";
    Collection["ApiKey"] = "api_key";
    Collection["GeoFenceSummary"] = "geofence_summary";
    Collection["IgnitionSummary"] = "ignition_summary";
    Collection["CNGManagement"] = "cng_management";
})(Collection = exports.Collection || (exports.Collection = {}));
var ReportFormatType;
(function (ReportFormatType) {
    ReportFormatType["CSV"] = "csv";
    ReportFormatType["PDF"] = "pdf";
    ReportFormatType["EXCEL"] = "excel";
    ReportFormatType["JSON"] = "json";
})(ReportFormatType = exports.ReportFormatType || (exports.ReportFormatType = {}));
var Geo;
(function (Geo) {
    Geo["UAE"] = "uae";
    Geo["SA"] = "sa";
    Geo["Test"] = "test";
    Geo["NG"] = "ng";
    Geo["AUH"] = "auh";
    Geo["NL"] = "nl";
})(Geo = exports.Geo || (exports.Geo = {}));
var Country;
(function (Country) {
    Country["UAE"] = "United Arab Emirates";
    Country["SA"] = "Saudi Arabia";
    Country["NG"] = "Nigeria";
    Country["Netherlands"] = "Netherlands";
})(Country = exports.Country || (exports.Country = {}));
const geoCountryMap = {
    [Geo.UAE]: 'United Arab Emirates',
    [Geo.SA]: 'Saudi Arabia',
    [Geo.Test]: 'Tenderdland',
    [Geo.NG]: 'Nigeria',
    [Geo.AUH]: 'Abu Dhabi',
    [Geo.NL]: 'Netherlands'
};
const getCountry = (geo) => {
    return geoCountryMap[geo];
};
exports.getCountry = getCountry;
exports.EquipmentTypes = [
    "all machines",
    "air compressor",
    "all terrain crane",
    "articulated dump truck",
    "asphalt paver machine",
    "asphalt saw cutter",
    "asphalt team",
    "backhoe loader",
    "bitumen tanker",
    "boom lift",
    "boom loader",
    "box truck",
    "bulldozer",
    "bundle puller",
    "bus",
    "concrete mixer",
    "concrete pump",
    "construction barge",
    "crawler crane",
    "diesel tanker",
    "double drum roller",
    "dump truck",
    "excavator attachment",
    "excavator crawler",
    "excavator long boom",
    "excavator wheel",
    "flat top barge",
    "forklift",
    "generator",
    "hiab crane",
    "laser scanner",
    "lifting cradle",
    "lighting tower",
    "loadbank",
    "lowbed",
    "flatbed",
    "man lift",
    "milling machine",
    "mobile tire crane",
    "motor grader",
    "pickup truck",
    "plate compactor",
    "pneumatic tyred roller",
    "power pallet truck",
    "push barge",
    "reach truck",
    "recovery truck",
    "refrigerated truck",
    "refrigerated van",
    "rigid truck",
    "ride on roller",
    "ride on scrubber",
    "rough terrain crane",
    "scissor lift",
    "single drum roller",
    "skid steer loader",
    "spider crane",
    "spider lift",
    "stabilizer",
    "sweet water tanker",
    "trailer",
    "trencher",
    "truck mounted man lift",
    "tug boat",
    "walk behind compactor",
    "waste water tanker",
    "water tanker",
    "vaccum tanker",
    "van",
    "wheel loader shovel",
    "",
].map((a) => ({
    value: a,
    label: a.replace(/^\w/, (c) => c.toUpperCase()),
}));
exports.KSAStates = [
    {
        label: "",
        value: ""
    }
].map((a) => ({
    value: a.value,
    label: a.label,
}));
exports.UAEStates = [
    {
        label: "Dubai",
        value: "DXB"
    },
    {
        label: "Abu Dhabi",
        value: "AUH"
    },
    {
        label: "Sharjah",
        value: "SHJ"
    },
    {
        label: "Ajman",
        value: "AJM"
    },
    {
        value: "RAK",
        label: "Ras Al Khaimah"
    },
    {
        value: "FUJ",
        label: "Fujairah"
    },
    {
        value: "UAQ",
        label: "Umm Al Quwain"
    }
].map((a) => ({
    value: a.value,
    label: a.label,
}));
;
/*
export let Units = [
  'ton',
  'feet',
  'kg',
  'metres',
  'gallon',
  'cubic metres',
  'seats',
  'watt',
  'kva',
  'cfm',
  'inches',
  'heads',
  'axle'
]
*/
var SortDirection;
(function (SortDirection) {
    SortDirection["DESC"] = "desc";
    SortDirection["ASC"] = "asc";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
//# sourceMappingURL=base.js.map